import styled from 'styled-components'

interface IProps {
  text: string
  dataTestId?: string
  labelId?: string
}

export const SubduedLabel = ({ text, dataTestId, labelId }: IProps) => {
  return (
    <Span className={labelId} data-testid={dataTestId}>
      {text}
    </Span>
  )
}

const Span = styled.span`
  display: inline-block;
  color: ${({ theme }) => theme.colors.grey.neutral};
  font-family: Milliard;
  font-style: normal;
  ${({ theme }) => theme.typography.xs.medium};
  border-radius: 5px;
`
